import { createApp } from "vue";
import html from "./importproduct.html";
import { dropzoneFile } from "./composant/dropezoneFile";

const js = {
  url: function (echangeur) { },
  onLoad: function (echangeur) {
    const THIS = this;

    const app = createApp({

      data() {
        return {};
      },

      methods: {
        async analyzeFile(filename) {
          await THIS.rest("b2b.product.test", { filename: filename });
        },
      },

      components: {
        "dropzone-file": dropzoneFile,
      },
    });

    this.vm = app.mount(THIS.c$("._vueChargement")[0]);
  },
};

export default {
  importproduct: { js, html },
};
